exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".resetPasswordPage .resetForm{width:220px;margin:0 auto;margin-bottom:20px}.resetPasswordPage .validatingInput{margin-bottom:10px}.resetPasswordPage .btnLine{text-align:center;margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/logins/reset_password_page.scss
// module id = 1315
// module chunks = 0